<div class="modal-header">
  <h2 class="modal-title">
    {{ 'serieProposalModule.serieProposal' | translate }}:
    {{
      serieProposalItem?.linkedProductId
        | getTranslation: 'product' : 'description'
        | async
    }}
  </h2>

  <button
    type="button"
    class="btn-close"
    attr.aria-label="{{ 'wcag.close' | translate }}"
    (click)="cancel()"
  >
  </button>
</div>

<div class="modal-body">
  <h3
    class="mb-3 h4"
    *ngIf="serieProposalItem.status == serieProposalItemStatus.COUNTER_PROPOSAL"
  >
    {{ 'serieProposalModule.productIsNotAvailableAtRequestedTime' | translate }}
  </h3>

  <p>
    {{
      serieProposalItem.startDate.toDate()
        | date: 'EE dd MMM yyyy' : undefined : (selectedLanguage$ | async)
    }}
    {{ serieProposalItem.startDate.toDate() | date: 'HH:mm' }}
    -
    {{ serieProposalItem.endDate.toDate() | date: 'HH:mm' | roundMinutes }}
  </p>

  <form
    *ngIf="
      serieProposalItem.status == serieProposalItemStatus.REQUESTED ||
      serieProposalItem.status == serieProposalItemStatus.ACCEPTED
    "
    [formGroup]="form"
    #formRef="ngForm"
    (ngSubmit)="onFormSubmit()"
  >
    <div class="row mb-4">
      <div class="col-12">
        <label class="form-label">
          {{ 'general.location' | translate }}
        </label>

        <product-select-input
          (search)="onSearchProducts($event)"
          [products]="locations$ | async"
          formControlName="locationId"
          [allowClearing]="false"
          class="flex-grow-1"
        ></product-select-input>
      </div>

      <p
        class="invalid-feedback"
        role="alert"
        aria-atomic="true"
        *ngIf="
          form.controls.locationId.dirty && form.controls.locationId.invalid
        "
      >
        {{ 'productModule.resource' | translate }}
        {{ 'general.isInvalid' | translate }}
      </p>
    </div>

    <div class="row mb-4">
      <div class="col-12">
        <label class="form-label">
          {{ 'productModule.resource' | translate }}
        </label>

        <div class="input-group">
          <product-select-input
            (search)="onSearchProducts($event)"
            [products]="resources$ | async"
            formControlName="productId"
            [allowClearing]="false"
            class="flex-grow-1"
          ></product-select-input>
        </div>

        <p
          class="invalid-feedback"
          role="alert"
          aria-atomic="true"
          *ngIf="
            form.controls.productId.dirty && form.controls.productId.invalid
          "
        >
          {{ 'productModule.resource' | translate }}
          {{ 'general.isInvalid' | translate }}
        </p>
      </div>
    </div>
    <fieldset class="mb-4">
      <legend class="form-label">
        {{ 'general.newDate' | translate }}
      </legend>

      <datetime-input
        [minDate]="minDate"
        [hideTime]="true"
        formControlName="startDate"
        [attr.aria-invalid]="
          form.controls.startDate.dirty && form.controls.startDate.invalid
            ? 'true'
            : null
        "
      ></datetime-input>

      <p
        class="invalid-feedback"
        role="alert"
        aria-atomic="true"
        *ngIf="form.controls.startDate.dirty && form.controls.startDate.invalid"
      >
        <i role="img" class="fas fa-exclamation-circle" aria-hidden="true"></i>
        {{ 'general.value' | translate }}
        {{ 'general.isInvalid' | translate }}
      </p>
    </fieldset>
    <div class="row mb-4">
      <fieldset class="col-auto d-flex align-items-center">
        <legend class="inline-form-label">
          {{ 'general.from' | translate }}
        </legend>
        <time-input
          [minuteStep]="30"
          formControlName="startTime"
          class="ms-2"
        ></time-input>
      </fieldset>

      <fieldset class="col-auto d-flex align-items-center">
        <legend class="inline-form-label">
          {{ 'serieProposalModule.till' | translate }}
        </legend>
        <time-input [minuteStep]="30" formControlName="endTime"></time-input>
      </fieldset>
    </div>

    <div class="d-flex justify-content-end">
      <button class="btn btn-primary" [disabled]="!form.dirty">
        {{ 'general.save' | translate }}
      </button>
    </div>
  </form>

  <div
    *ngIf="serieProposalItem.status == serieProposalItemStatus.COUNTER_PROPOSAL"
    class="d-flex"
    [ngClass]="{
      'justify-content-between': serieProposalItem?.id,
      'justify-content-end': !serieProposalItem?.id
    }"
  >
    <button
      class="btn btn-soft-primary"
      type="button"
      (click)="onClickDeclineProposalItem()"
    >
      {{ 'general.decline' | translate }}
    </button>
    <button
      class="btn btn-primary"
      type="button"
      (click)="onClickAcceptCounterProposal()"
    >
      {{ 'general.accept' | translate }}
    </button>
  </div>
</div>
